import { render, staticRenderFns } from "./iModal.vue?vue&type=template&id=53006ee2&scoped=true&"
import script from "./iModal.vue?vue&type=script&lang=js&"
export * from "./iModal.vue?vue&type=script&lang=js&"
import style0 from "./iModal.vue?vue&type=style&index=0&id=53006ee2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53006ee2",
  null
  
)

export default component.exports